<template>
  <div>
    <b-modal
      id="modalImportar"
      title="Importar Beneficiários"
      centered
      no-close-on-backdrop
      cancel-title="Cancelar"
      hide-footer
    >
      <form @submit.prevent="submitImportar" ref="submitImportar">
        <div class="row">
          <form-select
            v-model="item.programa"
            grid="12"
            label="Programa"
            :itens="$root.arrays.programas_importacao"
          />

          <form-file
            label="Enviar arquivo tratado no formato CSV"
            @submit="submitFile"
            btn-text="Iniciar"
            :progress="progressCompleted"
            ajuda="O arquivo deverá ser convertido antes de ser enviado assita o <a href='#'>vídeo tutorial</a> e veja como fazer."
            textInput="Localizar arquivo"
          />
        </div>
        <div class="row pt-4 px-0 d-flex justify-content-end">
          <div class="col-auto px-2 text-right">
            <button
              class="btn btn-success btn-submit"
              data-style="zoom-in"
              type="submit"
            >
              <i class="mdi mdi-content-save" />
              {{ $t("Salvar") }}
            </button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "ImportarSisc",
  data() {
    return {
      item: {},
      file: null,
      progressCompleted: 0,
    };
  },
  methods: {
    submitFile(file) {
      var array = file.name.split(".");
      var extension = array[array.length - 1];
      if (extension.toLowerCase() == "csv") {
        this.file = file;
      } else {
        swal.fire({
          icon: "error",
          title: "Formato invalido!",
          text: "Apenas arquivos do .txt e .zip são aceitos.",
          showConfirmButton: false,
          timer: 4000,
        });
      }
    },
    submitImportar() {
      let formData = new FormData();

      if (this.file == null) {
        swal.fire({
          icon: "error",
          title: "Erro!",
          text: "Nenhum arquivo foi selecionado.",
          showConfirmButton: true,
          timer: 4000,
        });
        return false;
      }

      for (var key in this.item) {
        formData.append(key, this.item[key]);
      }

      formData.append("file", this.file);
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();
      axios
        .post(`api/dashboard/importar/programas`, formData, {
          header: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (event) => {
            let progress = Math.round((event.loaded * 100) / event.total);
            this.progressCompleted = progress;
          },
        })
        .then((response) => {
          ladda.stop();
          swal.fire({
            icon: "success",
            title: "Importação inciada!",
            html: response.data.data.message,
            showConfirmButton: false,
            timer: 4000,
          });
          this.$bvModal.hide("modalImportar");
          this.$parent.getItens();
        })
        .finally(() => {
          this.progressCompleted = 0;
          this.files = [];
        })
        .catch((error) => {
          swal.fire({
            title: "Ops!",
            html: "Algo de errado aconteceu!<br>" + error,
            icon: "error",
          });
        });
    },
  },
};
</script>
